import { KeyValue, SectionListKeyValue } from "../models/KeyValue";

export const EconomyChartFigures: KeyValue[] = [
	{ key: "Omsättning", value: "Omsättning" },
	{ key: "Bruttovinst", value: "Bruttovinst" },
	{ key: "Genomsnittlig kostna", value: "Genomsnittlig kostna" },
	{ key: "Genomsnittligt pris", value: "Genomsnittligt pris" },
];

export const ResourcesChartFiguresForYear: KeyValue[] = [
	{ key: "Bokade pass", value: "Bokade pass" },
	{ key: "Nekade pass", value: "Nekade pass" },
	{ key: "Sålda timmar", value: "Sålda timmar" },
	{ key: "Ansökningar", value: "Ansökningar" },
	{ key: "Nyanställda", value: "Nyanställda" },
	{ key: "Aktiva konsulter", value: "Aktiva konsulter" },
	{ key: "Arbetande konsulter", value: "Arbetande konsulter" },
];

export const EconomyChartFiguresForDay: SectionListKeyValue[] = [
	{ header: "Omsättning", value: [] },
	{ header: "Bruttovinst", value: [] },
];

export const ResourceChartFiguresForDay: SectionListKeyValue[] = [
	{ header: "Sålda timmar", value: [] },
	{ header: "Bokade pass", value: [] },
];

export const ResourcesChartFigures: SectionListKeyValue[] = [
	{ header: "Arbetande konsulter", value: [] },
	{ header: "Aktiva konsulter", value: [] },
	{ header: "Bokade pass", value: [] },
	{ header: "Sålda timmar", value: [] },
];
